import React from 'react';
import { ScreenProps } from '../ScreenBase';
import styles from './scale.module.css';
import commonStyles from '../screenbase.module.css';
import NextButton from '../NextButton';

class Scale extends React.Component<ScreenProps> {
  state = {
    value: null,
  };

  setValue = (value?: number) => {
    const { onSubmit, locked } = this.props;
    if (!locked) {
      onSubmit({ value });
      this.setState({ value });
    }
  };

  render() {
    const {
      data: { min_value, max_value, extended_props, required },
      locked,
    } = this.props;
    const { min_label, max_label, button_text } = extended_props || {};
    const numbers = Array.from(
      new Array((max_value || 10) - (min_value || 0) + 1),
      (x, i) => i + (min_value || 0)
    );

    return (
      <>
        <div className={styles.labels}>
          <div className={commonStyles.note}>{min_label || 'Nunca'}</div>
          <div className={commonStyles.note}>{max_label || 'Siempre'}</div>
        </div>
        <div className={`${styles.scaleBar} ${locked ? styles.locked : ''}`}>
          {numbers.map((i) => (
            <div
              key={i}
              className={this.state.value === i ? styles.selected : undefined}
              onClick={() => this.setValue(i)}
            >
              {i}
            </div>
          ))}
        </div>
        <NextButton
          visible={!required}
          type='link'
          style={{ textDecoration: 'underline' }}
          text={button_text || 'Omitir'}
          onClick={() => this.setValue()}
        />
      </>
    );
  }
}

export default Scale;
